import { Role } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useRole } from '../../hooks/useRole';

export const HocuspocusDebugMenu = (props: ChakraV3.ButtonProps) => {
  const isSupport = useRole(Role.Support);

  if (!isSupport) {
    return null;
  }

  const onDisconnect = () => {
    window.__hocuspocusProvider?.disconnect();
  };

  const onReconnect = () => {
    window.__hocuspocusProvider?.connect();
  };

  const onRefreshAuthToken = async () => {
    await window.__refreshAuthToken?.();
  };

  return (
    <ChakraV3.Menu.Root>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button size='sm' variant='outline' {...props}>
          Debug
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem value='disconnect' onClick={onDisconnect}>
            Disconnect
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem value='reconnect' onClick={onReconnect}>
            Reconnect
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem value='refresh-auth-token' onClick={onRefreshAuthToken}>
            Refresh auth token
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
